<template>
  <div class="guide">
    <div class="guide-title">
      Quick Guide to determine the type of fixtures in your home
    </div>
    <div class="question-title">How to determine your toilet type?</div>
    <p>
      The number of gallons per flush is marked on most newer model toilets
      (behind the seat hinge at the base of the bowl). Tip: Toilets built before
      1982 use 5 to 7 gallons per flush. Now, toilets are designed to flush
      using only 1.6 gallons of water or less. Use
      <a href="#" @click.prevent="setHelper('F431')">this simple guide</a>
      to help you determine how many gallons per flush you toilet uses.
    </p>
    <div class="question-title">How to determine your shower head type?</div>
    <p>
      Showerheads may or may not be labeled. Use
      <a href="#" @click.prevent="setHelper('F431')">this simple guide</a> to
      determine the flow rate of your shower head whether or not it is labeled.
    </p>
    <div class="question-title">How to determine your faucet type?</div>

    <p>
      Faucets may or may not be labeled. Use
      <a href="#" @click.prevent="setHelper('F431')">this simple guide</a> to
      determine the flow rate of your faucet whether or not it is labeled.
    </p>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "Guide",
  props: {},
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {
    ...mapActions("Helpers", ["setHelper"]),
  },
};
</script>
<style lang="scss" scoped>
.guide {
  padding: 0 16px;
  .guide-title {
    font-size: 19px;
  }
  .question-title {
    font-size: 16px;
    font-weight: 600;
    margin-top: 12px;
  }
  p,
  a {
    font-size: 16px;
  }
  a {
    font-weight: 600;
  }
}
</style>
